// Immediately hide None options before page fully loads
(function() {
    // Add CSS rule immediately to prevent flash
    var style = document.createElement('style');
    style.textContent = '#infiniteoptions-container input[value="None"], #infiniteoptions-container label:has(input[value="None"]) { display: none !important; }';
    document.head.appendChild(style);
})();

// Wait for DOM to be ready for additional functionality
document.addEventListener('DOMContentLoaded', function() {

    // Enhanced function to hide None option
    function hideNoneOption() {
        // Find all None radio inputs
        const radioInputs = document.querySelectorAll('#infiniteoptions-container input[type="radio"][value="None"]');
        radioInputs.forEach(function(input) {
            // Hide the input itself
            input.style.display = 'none';
            input.style.visibility = 'hidden';

            // Hide the parent label
            const label = input.closest('label');
            if (label) {
                label.style.display = 'none';
                label.style.visibility = 'hidden';
                label.style.position = 'absolute';
                label.style.left = '-9999px';
            }

            // Also hide the parent if it's a wrapper
            const parent = input.parentElement;
            if (parent && parent.tagName === 'LABEL') {
                parent.style.display = 'none';
                parent.style.visibility = 'hidden';
            }
        });
    }

    const durabilitySettings = window.durabilityUpgradeSettings || {};
    const DURABILITY_REQUIRED_SHAPES = ['oval', 'cushion', 'emerald', 'marquise', 'moval'];
    const DURABILITY_REQUIREMENT_ERROR_MESSAGE = durabilitySettings.durabilityRequirementErrorText || 'Durability upgrade required for stones over 4ct.';
    let durabilityRequirementActive = false;
    let currentDurabilityShape = '';
    let cachedDurabilityGroup = null;
    let durabilityErrorElement = null;

    function normalizeValue(value) {
        return value ? value.toString().toLowerCase().trim() : '';
    }

    function labelMatchesStone(text) {
        if (!text) return false;
        const normalized = text.toString().toLowerCase();
        if (normalized.includes('stone shape')) return true;
        if (normalized.includes('stone') && normalized.includes('shape')) return true;
        return false;
    }

    function detectedShapeMatchesRequirement(value) {
        const normalized = normalizeValue(value);
        if (!normalized) return '';
        for (let i = 0; i < DURABILITY_REQUIRED_SHAPES.length; i++) {
            const shape = DURABILITY_REQUIRED_SHAPES[i];
            const pattern = new RegExp(`(^|[^a-z0-9])${shape}([^a-z0-9]|$)`);
            if (pattern.test(normalized)) {
                return shape;
            }
        }
        return '';
    }

    function getCurrentStoneShape() {
        const productVariantSelects = document.querySelector('product-variant-selects');
        if (productVariantSelects) {
            const fieldsets = productVariantSelects.querySelectorAll('fieldset.product__variant-options');
            for (const fieldset of fieldsets) {
                const legend = fieldset.querySelector('legend.form__label, legend');
                if (legend && labelMatchesStone(legend.textContent)) {
                    const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
                    if (checkedInput && checkedInput.value) {
                        return normalizeValue(checkedInput.value);
                    }
                }
            }

            const selects = productVariantSelects.querySelectorAll('select');
            for (const select of selects) {
                const label = select.closest('.product-form__input')?.querySelector('label.form__label, label');
                if (label && labelMatchesStone(label.textContent) && select.value) {
                    return normalizeValue(select.value);
                }
            }
        }

        const checkedRadios = document.querySelectorAll('input[type="radio"]:checked');
        for (const radio of checkedRadios) {
            if (labelMatchesStone(radio.name) && radio.value) {
                return normalizeValue(radio.value);
            }
            const radioLabel = radio.closest('label');
            if (radioLabel && labelMatchesStone(radioLabel.textContent) && radio.value) {
                return normalizeValue(radio.value);
            }
        }

        const allSelects = document.querySelectorAll('select');
        for (const select of allSelects) {
            const label = select.closest('.product-form__input')?.querySelector('label.form__label, label');
            if ((labelMatchesStone(select.name) || (label && labelMatchesStone(label.textContent))) && select.value) {
                return normalizeValue(select.value);
            }
        }

        return '';
    }

    function variantMatchesRequirement(variant) {
        if (!variant) return '';
        const values = [];
        if (Array.isArray(variant.options)) {
            values.push(...variant.options);
        }
        ['option1', 'option2', 'option3', 'option4', 'option5', 'title', 'name', 'public_title'].forEach(function(key) {
            if (variant[key]) {
                values.push(variant[key]);
            }
        });
        for (let i = 0; i < values.length; i++) {
            const match = detectedShapeMatchesRequirement(values[i]);
            if (match) {
                return match;
            }
        }
        return '';
    }

    function getDurabilityContainer() {
        return document.getElementById('infiniteoptions-container') || null;
    }

    function getDurabilityGroupElement() {
        if (cachedDurabilityGroup && document.body.contains(cachedDurabilityGroup)) {
            return cachedDurabilityGroup;
        }
        const container = getDurabilityContainer();
        if (!container) return null;

        let group = container.querySelector('div[role="group"][aria-labelledby*="Durability"]');
        if (!group) {
            const possibleGroups = container.querySelectorAll('div[role="group"], fieldset, .spb-field, .spb-option, .io-choices, .infiniteoptions-options');
            for (const element of possibleGroups) {
                if (isDurabilityGroup(element)) {
                    group = element;
                    break;
                }
            }
        }

        if (group) {
            cachedDurabilityGroup = group;
            return group;
        }

        return null;
    }

    function ensureDurabilityErrorElement() {
        if (durabilityErrorElement && document.body.contains(durabilityErrorElement)) {
            return durabilityErrorElement;
        }
        const group = getDurabilityGroupElement();
        if (!group) return null;

        let error = group.parentNode ? group.parentNode.querySelector('#durability-upgrade-error') : null;
        if (!error) {
            error = document.createElement('div');
            error.id = 'durability-upgrade-error';
            error.className = 'ring-size-error durability-upgrade-error';
            error.style.display = 'none';
            error.style.fontSize = '1.3rem';
            error.style.marginTop = '6px';
            error.style.marginBottom = '20px';
            error.style.textAlign = 'left';
            error.style.padding = '12px 16px';
            error.style.boxSizing = 'border-box';
            error.setAttribute('role', 'alert');
            error.setAttribute('aria-live', 'polite');
            error.textContent = '';

            const insertAfter = group.nextElementSibling;
            if (insertAfter && insertAfter.parentNode) {
                insertAfter.parentNode.insertBefore(error, insertAfter);
            } else if (group.parentNode) {
                group.parentNode.appendChild(error);
            }
        }

        durabilityErrorElement = error;
        durabilityErrorElement.style.fontSize = '1.3rem';
        durabilityErrorElement.style.marginTop = '6px';
        durabilityErrorElement.style.marginBottom = '20px';
        durabilityErrorElement.style.textAlign = 'left';
        durabilityErrorElement.style.padding = '12px 16px';
        durabilityErrorElement.style.boxSizing = 'border-box';
        return durabilityErrorElement;
    }

    function setDurabilityGroupErrorState(isError) {
        const group = getDurabilityGroupElement();
        if (!group) return;
        group.classList.toggle('durability-upgrade-missing', !!isError);
        const radios = group.querySelectorAll('input[type="radio"]');
        radios.forEach(function(radio) {
            if (isError) {
                radio.setAttribute('aria-invalid', 'true');
            } else {
                radio.removeAttribute('aria-invalid');
            }
        });
    }

    function hideDurabilityError() {
        const error = ensureDurabilityErrorElement();
        if (error) {
            error.style.display = 'none';
        }
        setDurabilityGroupErrorState(false);
    }

    function showDurabilityError(message) {
        const error = ensureDurabilityErrorElement();
        if (!error) return;
        error.textContent = message;
        error.style.display = 'block';
        setDurabilityGroupErrorState(true);

        const group = getDurabilityGroupElement();
        if (group) {
            group.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    function isDurabilityUpgradeSelected() {
        const group = getDurabilityGroupElement();
        if (!group) return false;
        const checked = group.querySelector('input[type="radio"]:checked');
        if (!checked) return false;
        const value = normalizeValue(checked.value);
        return value && value !== 'none';
    }

    function getGroupRoot(node) {
        return node.closest('div[role="group"], fieldset, .spb-option, .spb-field, .io-choices, .infiniteoptions-options');
    }

    function isDurabilityGroup(element) {
        if (!element) return false;

        const attrStrings = [
            element.getAttribute('aria-labelledby'),
            element.getAttribute('aria-label'),
            element.id
        ];

        if (element.dataset) {
            attrStrings.push(element.dataset.name, element.dataset.title, element.dataset.optionName);
        }

        if (attrStrings.some(function(value) {
            return value && value.toLowerCase().includes('durability');
        })) {
            return true;
        }

        const headingCandidates = element.querySelectorAll('label, legend, .spb-label-tooltip, .spb-label-tooltip label, [class*="label"], [class*="title"], [class*="heading"]');
        for (let i = 0; i < headingCandidates.length; i++) {
            const text = (headingCandidates[i].textContent || '').toLowerCase();
            if (text.includes('durability')) {
                return true;
            }
        }

        const previousSibling = element.previousElementSibling;
        if (previousSibling && (previousSibling.textContent || '').toLowerCase().includes('durability')) {
            return true;
        }

        return false;
    }

    function getCurrentStoneCarat() {
        const stoneCaratDropdown = document.getElementById('StoneCaratDropdown');
        if (!stoneCaratDropdown || !stoneCaratDropdown.value) return 0;

        // Extract the numeric value from options like "4.00-4.99 Carat"
        const value = stoneCaratDropdown.value;
        const match = value.match(/^(\d+(?:\.\d+)?)/);
        if (match && match[1]) {
            return parseFloat(match[1]);
        }
        return 0;
    }

    function updateDurabilityRequirementState(variant) {
        let matchedShape = variantMatchesRequirement(variant);
        if (!matchedShape) {
            const domShape = getCurrentStoneShape();
            matchedShape = detectedShapeMatchesRequirement(domShape);
        }

        // Check if stone carat is 4 or above
        const currentCarat = getCurrentStoneCarat();
        const caratRequirement = currentCarat >= 4;

        // Durability upgrade is required if BOTH conditions are met:
        // 1. Stone shape matches one of the required shapes
        // 2. Stone carat is 4 or above
        durabilityRequirementActive = !!matchedShape && caratRequirement;
        currentDurabilityShape = matchedShape;

        window.durabilityUpgradeRequirement = {
            requiresUpgrade: durabilityRequirementActive,
            stoneShape: currentDurabilityShape,
            stoneCarat: currentCarat
        };

        if (!durabilityRequirementActive || isDurabilityUpgradeSelected()) {
            hideDurabilityError();
        }
    }

    function shouldValidateDurability(form) {
        if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return false;
        if (form.closest('.cart-drawer') || form.classList.contains('cart-drawer__form')) return false;
        if (!getDurabilityGroupElement()) return false;
        return true;
    }

    function enforceDurabilityRequirement(event) {
        if (!durabilityRequirementActive) return false;
        if (isDurabilityUpgradeSelected()) {
            hideDurabilityError();
            return false;
        }

        showDurabilityError(DURABILITY_REQUIREMENT_ERROR_MESSAGE);
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        return true;
    }

    // Function to handle radio button selection state
    function handleRadioSelection() {
        const container = document.querySelector('#infiniteoptions-container');
        if (!container) return;

        const radioInputs = container.querySelectorAll('input[type="radio"]');

        radioInputs.forEach(function(input) {
            // Avoid attaching duplicate listeners
            if (input.__ioListenersAttached) return;
            input.__ioListenersAttached = true;

            input.addEventListener('change', function() {
                const groupRoot = getGroupRoot(this);
                if (groupRoot) {
                    groupRoot.querySelectorAll('label').forEach(function(label) {
                        label.classList.remove('selected');
                    });
                }

                if (this.value === 'None') {
                    return;
                }

                let currentLabel = this.closest('label');
                if (!currentLabel && this.id) {
                    currentLabel = container.querySelector('label[for="' + this.id.replace(/"/g, '\\"') + '"]');
                }
                if (currentLabel && this.checked) {
                    currentLabel.classList.add('selected');
                }

                if (durabilityRequirementActive && this.value && this.value.toLowerCase() !== 'none') {
                    hideDurabilityError();
                }
            });

            if (input.value === 'None') {
                return;
            }

            let labelEl = input.closest('label');
            if (!labelEl && input.id) {
                labelEl = container.querySelector('label[for="' + input.id.replace(/"/g, '\\"') + '"]');
            }
            if (labelEl && !labelEl.__ioClickBound) {
                labelEl.__ioClickBound = true;

                const rememberState = function() {
                    input.__ioWasChecked = input.checked;
                };

                labelEl.addEventListener('pointerdown', rememberState);
                labelEl.addEventListener('mousedown', rememberState);
                labelEl.addEventListener('touchstart', rememberState, { passive: true });

                labelEl.addEventListener('click', function(e) {
                    const groupRoot = getGroupRoot(input);
                    const durabilityGroup = isDurabilityGroup(groupRoot);
                    const wasChecked = !!input.__ioWasChecked;
                    input.__ioWasChecked = undefined;

                    if (durabilityGroup && wasChecked) {
                        e.preventDefault();
                        e.stopPropagation();

                        const noneInput = groupRoot && groupRoot.querySelector('input[type="radio"][value="None"]');
                        if (noneInput) {
                            noneInput.checked = true;
                            noneInput.dispatchEvent(new Event('change', { bubbles: true }));
                        } else {
                            input.checked = false;
                            input.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                        return;
                    }

                    if (!input.checked) {
                        input.checked = true;
                        input.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                });
            }

            if (input.checked) {
                let initLabel = input.closest('label');
                if (!initLabel && input.id) {
                    initLabel = container.querySelector('label[for="' + input.id.replace(/"/g, '\\"') + '"]');
                }
                if (initLabel) {
                    initLabel.classList.add('selected');
                }
            }
        });
    }

    // Function to handle custom engraving checkbox
    function handleCustomEngraving() {
        const checkbox = document.querySelector('#infiniteoptions-container input[type="checkbox"]');
        if (!checkbox) return;

        // Find the text input container
        const textInputs = document.querySelectorAll('#infiniteoptions-container input[type="text"]');
        let textInputContainer = null;
        let textInput = null;

        textInputs.forEach(function(input) {
            if (input.id && input.id.includes('CUSTOM ENGRAVING TEXT')) {
                textInput = input;
                textInputContainer = input.closest('div');
            }
        });

        if (!textInputContainer) return;

        checkbox.addEventListener('change', function() {
            if (this.checked) {
                textInputContainer.style.display = 'block';
                textInputContainer.style.opacity = '1';
                textInputContainer.removeAttribute('disabled');

                if (textInput) {
                    textInput.removeAttribute('disabled');
                    textInput.setAttribute('name', 'properties[CUSTOM ENGRAVING TEXT]');
                }

                // Update the hidden input for custom engraving
                const hiddenInput = document.querySelector('input[type="hidden"][name="properties[Custom Engraving]"]');
                if (hiddenInput) {
                    hiddenInput.value = 'Custom Engraving (+$50)';
                }
            } else {
                textInputContainer.style.display = 'none';
                textInputContainer.style.opacity = '0';

                if (textInput) {
                    textInput.setAttribute('disabled', 'disabled');
                    textInput.value = '';
                }

                // Clear the hidden input for custom engraving
                const hiddenInput = document.querySelector('input[type="hidden"][name="properties[Custom Engraving]"]');
                if (hiddenInput) {
                    hiddenInput.value = '';
                }
            }
        });

        // Set initial state
        if (!checkbox.checked) {
            textInputContainer.style.display = 'none';
            textInputContainer.style.opacity = '0';
        }
    }

    // Run immediately
    hideNoneOption();
    handleRadioSelection();
    handleCustomEngraving();
    updateDurabilityRequirementState();

    // Initialize functions with slight delay for dynamic content
    setTimeout(function() {
        hideNoneOption();
        handleRadioSelection();
        handleCustomEngraving();
        updateDurabilityRequirementState();
    }, 100);

    // Also run when Infinite Options loads (in case it loads dynamically)
    setTimeout(function() {
        hideNoneOption();
        handleRadioSelection();
        handleCustomEngraving();
        updateDurabilityRequirementState();
    }, 1000);

    // Watch for DOM changes in case Infinite Options loads later
    const observer = new MutationObserver(function(mutations) {
        // Re-apply behaviors whenever Infinite Options mutates
        hideNoneOption();
        handleRadioSelection();
        handleCustomEngraving();
        updateDurabilityRequirementState();
    });

    const container = document.querySelector('#infiniteoptions-container');
    if (container) {
        observer.observe(container, {
            childList: true,
            subtree: true,
            attributes: false // Don't watch attribute changes to avoid loops
        });
    }

    document.addEventListener('variant:change', function(event) {
        updateDurabilityRequirementState(event?.detail?.variant);
    });

    const variantChangeEventName = (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) ? PUB_SUB_EVENTS.variantChange : 'variant-change';

    if (typeof subscribe === 'function' && variantChangeEventName) {
        try {
            subscribe(variantChangeEventName, function(payload) {
                const variant = payload && payload.data ? payload.data.variant : undefined;
                updateDurabilityRequirementState(variant);
            });
        } catch (e) {
            console.warn('Durability requirement subscription failed:', e);
        }
    }

    document.addEventListener('submit', function(event) {
        const form = event.target;
        if (!shouldValidateDurability(form)) return;
        updateDurabilityRequirementState();
        enforceDurabilityRequirement(event);
    }, true);

    document.addEventListener('click', function(event) {
        const button = event.target.closest('[name="add"], .btn-product-add, .product-form__submit, button[type="submit"], input[type="submit"]');
        if (!button) return;
        // Skip validation for sold out buttons - they redirect to a different page
        if (button.classList.contains('product-form__submit--sold-out')) return;
        const form = button.closest('form[data-product-form], form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
        if (!shouldValidateDurability(form)) return;
        updateDurabilityRequirementState();
        enforceDurabilityRequirement(event);
    }, true);

    document.addEventListener('change', function(event) {
        const target = event.target;
        if (!target) return;
        if (target.matches('.product__variant-options input[type="radio"], .product__variant-options select, select[name^="options"], input[name^="options"], [data-product-option] input[type="radio"], [data-product-option] select')) {
            setTimeout(function() {
                updateDurabilityRequirementState();
            }, 50);
        }
        // Also listen for stone carat dropdown changes
        if (target.id === 'StoneCaratDropdown') {
            setTimeout(function() {
                updateDurabilityRequirementState();
            }, 50);
        }
    });
});
